import { createSlice } from '@reduxjs/toolkit';
import { createTicket } from '../actions/TicketsActions';

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState: {
    creationStatus: 'idle',
    ticketId: '',
    dataTicket: '',
    message: '',
  },
  reducers: {
    resetCreation(state) {
      state.creationStatus = 'idle';
    },
    resetAlert(state) {
      state.ticketId = '';
      state.dataTicket = '';
    },
  },
  extraReducers: {
    // Handle createTicket actions
    [createTicket.pending]: (state) => {
      state.creationStatus = 'loading';
    },
    [createTicket.rejected]: (state) => {
      state.creationStatus = 'error';
    },

    [createTicket.fulfilled]: (state, action) => {
      if (action?.payload?.hasPendingTicket) {
        state.creationStatus = 'idle';
        state.ticketId = -1;
        state.dataTicket = action?.payload?.data || '';
        return;
      }

      state.creationStatus = action?.payload?.error ? 'error' : 'succeded';
      state.ticketId = action?.payload?.data.NumContacto || '';
      state.dataTicket = action?.payload.data || '';
      state.message = action?.payload?.msg || '';
    },
  },
});

export const { resetCreation, resetAlert } = ticketsSlice.actions;
export default ticketsSlice.reducer;
